import SettingsContent from '../Wrapper';
import AttributesHome from './Index';
import { frontendURL } from '../../../../helper/URLHelper';
import {requireAuth} from "../../dashboard.routes";
import {FEATURE_FLAGS} from "../../../../featureFlags";

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-attributes'),
      component: SettingsContent,
      props: {
        headerTitle: 'ATTRIBUTES_MGMT.HEADER',
        icon: 'code',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'attributes_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'attributes_list',
          component: AttributesHome,
          roles: ['administrator'],
          beforeEnter: requireAuth,
          meta: {
            permissions: ['administrator'],
            permission: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
          }
        },
      ],
    },
  ],
};
